<template>
  <div>
    <button @click="modelpopupbuttonClick()" rel="btncreateModel" class="btn btncreateModel">
      <span>
        <i class="fa fa-plus" aria-hidden="true"></i>
      </span>
      <b>Create Model</b>
    </button>
    <div class="modal-mask" v-if="showmodel === true">
      <div class="modal-wrapper">
        <div class="modelpopContainer">
          <section class="content">
            <div class="row">
              <div class="col-md-12">
                <a class="close-btn" @click="closeCreateModel()">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </a>
                <div class="topSteps clearfix">
                  <div class="stepsheading stepsin">Create Model</div>
                  <div
                    ref="step1arrow"
                    class="CreatelModelstep1 stepsin"
                    v-on:click="setstep(2)"
                    v-bind:class="(step >= 1) ? 'active' : ''"
                  >
                    <span>Step 1</span>
                    <i></i>
                  </div>
                  <div
                    ref="step2arrow"
                    class="CreatelModelstep2 stepsin"
                    v-on:click="setstep(2)"
                    v-bind:class="(step >= 2) ? 'active' : ''"
                  >
                    <span>Step 2</span>
                    <i></i>
                  </div>
                  <div
                    ref="step3arrow"
                    class="CreatelModelstep3 stepsin"
                    v-on:click="setstep(3)"
                    v-bind:class="(step3) ? 'active' : ''"
                  >
                    <span>Step 3</span>
                    <i></i>
                  </div>
                </div>
                <div class>
                  <!-- Input Addons -->
                  <div>
                    <!-- with icons from font awesome -->
                    <form @submit.prevent="formValid" method="POST" id="create-job-form">
                      <div class="error text-danger" v-if="(popmsgVisible)">{{ popinmessage }}</div>
                      <div class="createmodelStep1" v-if="step1">
                        <!-- <input ref="filecomp" id="myfilecsv" class="csvupload" type="file" @change="onmyFileChange" multiple="false"> -->
                        <label>
                          Name
                          <small>&nbsp; &nbsp;&nbsp; e.g. Monster | FR | Apply Start | 010117 - 310317</small>
                        </label>
                        <div class="input-group">
                          <input
                            class="form-control"
                            v-model="name"
                            data-vv-name="name"
                            name="name"
                            v-validate="'required'"
                            :class="{'input': true, 'error': errors.has('name') }"
                            placeholder="Enter ..."
                            type="text"
                            data-vv-validate-on="input|blur|submit"
                          >
                        </div>
                        <div class="clear-fix">
                          <span
                            v-show="errors.has('name')"
                            class="error text-danger"
                          >{{ errors.first('name') }}</span>
                        </div>
                        <br>
                        <!-- select examples -->
                        <div class="form-group" id="aclient">
                          <label>Client</label>
                          <select
                            class="form-control"
                            v-on:change="selectedClient(soption)"
                            v-model="soption"
                            data-vv-name="client"
                            name="client"
                            v-validate="'required'"
                            :class="{'input': true, 'error': errors.has('client') }"
                            data-vv-validate-on="input|blur|submit"
                          >
                            <option
                              v-for="(option, index) in res"
                              v-bind:value="index"
                              :key="option.clientname.name"
                            >
                              <!-- v-model="key" :key="key"> -->
                              {{ option.clientname.name }}
                            </option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label>Country</label>
                          <select
                            ref="selcountries"
                            :disabled="market.length == 0"
                            required
                            v-model="selectedMarket"
                            class="form-control"
                            value="label"
                            v-on:change="setselectedMarket()"
                            data-vv-name="market"
                            name="market"
                            v-validate="'required'"
                            :class="{'input': true, 'error': errors.has('market') }"
                            data-vv-validate-on="blur|submit"
                          >
                            <option value="label" disabled>Select a Country</option>
                            <option
                              v-for="(countries, key) in market"
                              v-bind:value="key"
                              :key="countries.name"
                            >{{countries.name}}</option>
                          </select>
                        </div>
                        <br>
                        <div v-if="selectedMarketSubmit" class="form-group">
                          <label>KPI</label>
                          <div class="clear-fix">
                            <span class="error text-danger" style="display:none">Please select a KPI</span>
                          </div>
                          <div class="kpiCheckbox checkbox">
                            <span v-for="(kpi, index) in kpi" v-bind:key="index">
                              <input
                                :id="kpi"
                                type="checkbox"
                                name
                                class
                                v-bind:value="kpi"
                                v-on:change="setselectedKpi()"
                                v-model="selectedKpi"
                              >
                              <label :for="kpi">{{kpi}}</label>
                            </span>
                          </div>
                        </div>
                        <div v-if="customerType">
                          <label>Customer Type</label>
                          <div class="clear-fix">
                            <span
                              class="error text-danger"
                              style="display:none"
                            >Please select a Customer Type</span>
                          </div>
                          <div class="kpiCheckbox checkbox">
                            <span v-for="(customerType, index) in customerType" v-bind:key="index">
                              <input
                                :id="customerType.value"
                                type="checkbox"
                                name
                                class
                                v-bind:value="customerType.value"
                                v-model="selectedcustomerType"
                              >
                              <label :for="customerType.value">{{customerType.name}}</label>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="createmodelStep2" v-if="step2">
                        <div class="form-group">
                          <label>Data Source</label>
                          <div ref="datasourceinfo" class="datasourceinfo">{{datasourceinfo}}</div>
                          <div
                            class="lookbackradio"
                            v-for="datasourcetype in datasourcetype"
                            v-bind:key="datasourcetype.value"
                          >
                            <input
                              type="radio"
                              v-bind:id="datasourcetype.name"
                              v-bind:value="datasourcetype.value"
                              checked
                              v-model="datasourceSelected"
                              @change="setdatasourceMessage(datasourcetype.message, datasourcetype.value)"
                            >
                            <label :for="datasourcetype.name">{{datasourcetype.name}}</label>
                          </div>
                        </div>

                        <label>Date Range</label>
                        <div class="form-group clearfix">
                          <!--                 <datepicker :readonly="true" format="MMM/D/YYYY" name="daterange" value="01/01/2015 - 01/31/2015" id="dateInput" width="100%"></datepicker> -->
                          <span v-if="selectedMarketSubmit" class="green labltimerange">
                            Available date range
                            <strong>{{start_date}} to {{end_date}}</strong> selected by default
                          </span>
                          <div style="margin-bottom: 10px">
                            <strong>
                              <span
                                class="missingdateerror"
                                v-if="dates_missing_in_window.length > 0"
                              >Data not available for dates - {{dates_missing_in_window}}</span>
                            </strong>
                          </div>

                          <datepicker
                            v-validate="'required'"
                            data-vv-value-path="time1"
                            required
                            v-model="time1"
                            v-bind:value="time1"
                            name="date1"
                            format="dd-MM-yyyy"
                            calendar-button
                            calendar-button-icon="fa fa-calendar"
                            placeholder="Enter Start Date"
                          ></datepicker>
                          <datepicker
                            v-validate="'required'"
                            data-vv-value-path="time2"
                            required
                            v-model="time2"
                            v-bind:value="time2"
                            name="date2"
                            format="dd-MM-yyyy"
                            calendar-button
                            calendar-button-icon="fa fa-calendar"
                            placeholder="Enter End Date"
                          ></datepicker>

                          <span
                            class="dateerror error"
                            style="display:none"
                          >Please enter date within available data range</span>
                        </div>
                        <div class="form-group">
                          <label>Week Commencing Day</label>
                          <select
                            required
                            v-model="commencingDay"
                            class="form-control"
                            value="label"
                            data-vv-name="week"
                            name="week"
                          >
                            <option value="label" disabled>Select a commencing day of week</option>
                            <option
                              v-for="(week, key) in week"
                              v-bind:value="(key + 1)"
                              :key="week.key"
                            >{{week}}</option>
                          </select>
                        </div>
                        <div class="form-group loogback-group">
                          <label>Lookback Window</label>
                          <div
                            v-for="lookbackwindow in lookbackwindow"
                            class="lookbackradio"
                            :key="lookbackwindow.value"
                          >
                            <input
                              type="radio"
                              v-bind:id="(lookbackwindow.value)"
                              v-model="lookbacktypeselected"
                              @change="setLookbacktype(lookbackwindow.value)"
                              v-bind:value="lookbackwindow.value"
                              v-bind:checked="lookbackSelected === 0 ? true : false "
                            >
                            <label v-bind:for="lookbackwindow.value">{{lookbackwindow.label}}</label>
                          </div>
                          <div class="enterlookback" v-if="lookbacktypeselected === 2">
                            <input
                              type="number"
                              v-model="lookbackSelected"
                              @change="checkLookbackNumber()"
                            >
                            <label>Days</label>
                            <span
                              v-bind:class="lookbackValid"
                              class="test"
                            >Minimum Value allowed is 1day and Maximum of 90days.</span>
                          </div>
                          <!-- <div class="predefinedlookback" v-if="predefinedlookback === true">
                            <div v-for="lookback in lookback" class="lookbackradio" :key="lookback.key">
                              <input type="radio" v-bind:id="(lookback.value)" v-model="lookbackSelected" v-bind:value="lookback.value" />
                              <label v-bind:for="lookback.value">{{lookback.label}}</label>
                            </div>
                          </div>-->
                        </div>
                      </div>
                      <div class="createmodelStep3" v-if="step3">
                        <div class="form-group">
                          <div style="margin-bottom: 10px">
                            <span
                              class="error reporterror"
                              style="display:none"
                            >Please select report type</span>
                          </div>
                          <div style="margin-bottom: 10px">
                            <strong>
                              <span
                                class="missingdateerror"
                                v-if="dates_missing_in_window.length > 0"
                              >Data not available for dates - {{dates_missing_in_window}}</span>
                            </strong>
                          </div>
                          <label class="display-block">Report Type</label>

                          <div
                            v-for="reporttype in reporttype"
                            v-bind:key="reporttype.key"
                            class="lookbackradio"
                          >
                            <input
                              type="radio"
                              v-bind:id="(reporttype.name)"
                              v-model="reporttypeSelected"
                              v-bind:value="reporttype.value"
                              @change="reporttypeChange()"
                            >
                            <label v-bind:for="reporttype.name">{{reporttype.name}}</label>
                          </div>
                        </div>
                        <div
                          class="form-group"
                          v-if="(copymodel === true) && channelgroupings === 'new'"
                        >
                          <Label>Use last uploaded channel groupings</Label>
                          <div class="togglebutton">
                            <span>
                              <input
                                id="yes"
                                value="yes"
                                type="radio"
                                name="existing_channel_groupings"
                                :selected="existing_channel_groupings_copy === 'yes' ? true : false"
                                v-model="existing_channel_groupings_copy"
                              >
                              <label
                                for="yes"
                                v-bind:class="existing_channel_groupings_copy === 'yes' ? 'active' : ''"
                              >Yes</label>
                            </span>
                            <span>
                              <input
                                id="no"
                                type="radio"
                                value="no"
                                name="existing_channel_groupings"
                                :selected="existing_channel_groupings_copy === 'yes' ? false : true"
                                v-model="existing_channel_groupings_copy"
                              >
                              <label
                                for="no"
                                v-bind:class="existing_channel_groupings_copy === 'yes' ? '' : 'active'"
                              >No</label>
                            </span>
                            <a v-bind:href="channel_grouping_url" download>Download</a>
                          </div>
                        </div>
                        <div class="form-group">
                          <Label>Channel Grouping Method</Label>
                          <div v-if="selectedMarketSubmit" class="channel-grouping-msg">
                            Latest master-channel-groupings file was uploaded by
                            <b>{{ chusername }} on {{ chagroupingdate }}</b>
                            <a
                              id="downloadchannelgrouping"
                              style="visibility:hidden"
                              class="btn btn-lrg btn-primary download-channel-grouping"
                            >Download Latest</a>
                          </div>
                          <div class="lookbackradio">
                            <input
                              name="channel-grouping"
                              type="radio"
                              id="chg-master"
                              value="master"
                              v-model="channelgroupings"
                            >
                            <label for="chg-master">Use existing master channel grouping file</label>
                          </div>
                          <div class="lookbackradio">
                            <input
                              name="channel-grouping"
                              type="radio"
                              id="chg-new"
                              value="new"
                              v-model="channelgroupings"
                            >
                            <label for="chg-new">Upload job specific channel grouping file</label>
                          </div>
                          <div class="lookbackradio">
                            <input
                              name="channel-grouping"
                              type="radio"
                              id="chg-newmaster"
                              value="newmaster"
                              v-model="channelgroupings"
                            >
                            <label for="chg-newmaster">Upload a new master channel grouping file</label>
                          </div>
                          <div
                            v-if="channelgroupings === 'new' || channelgroupings === 'newmaster'"
                          >
                            <label>Channel Grouping CSV file</label>
                            <!-- <input class="csvupload" type="file" @change="onFileChange" multiple="false" required> -->
                            <div class="upload-btn-wrapper">
                              <!-- <button class="btn btn-primary btn-large">Upload a file</button> -->
                              <input
                                :disabled="copymodel === true && existing_channel_groupings_copy === 'yes' ? true : false"
                                ref="filecomp"
                                id="myfilecsv"
                                class="csvupload"
                                type="file"
                                @change="onmyFileChange"
                                multiple="false"
                                required
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="Createjob-btnswrapper clearfix">
                        <button
                          id="Prevcreatejotbtn"
                          @click="gotoBackStep()"
                          type="button"
                          class="btn btn-primary btn-large"
                          v-if="(step !== 1)"
                        >Previous Step</button>
                        <button
                          ref="buttoncreatejob"
                          id="createjotbtn"
                          type="submit"
                          class="btn btn-primary btn-large"
                          v-bind:class="(submit) ? 'enabled' : 'disabled'"
                          @click="validdateStep3()"
                          v-if="(step === 3)"
                        >Create Model</button>
                        <button
                          id="Nextcreatejotbtn"
                          @click="gotoNextStep()"
                          type="button"
                          class="btn btn-primary btn-large"
                          v-if="(step < 3)"
                        >Next Step</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
jQuery = $
var moment = require('moment')
import Vue from 'vue'
import VeeValidate from 'vee-validate'
// import { pingpong } from './pingpongloader'
// import DatePicker from 'vue2-datepicker'
// import Simplert from 'vue2-simplert-plugin'
import Datepicker from 'vuejs-datepicker'
// var dateparse = require('date-fns/parse')
// import vue2Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'
// var areRangesOverlapping = require('date-fns/are_ranges_overlapping')
var differenceInDays = require('date-fns/difference_in_days')
// var res = require('../../../static/json/clientdata.json')
// res = res['client']
// var userchk = window.localStorage.getItem('user')
const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  enableAutoClasses: true,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true
}

Vue.use(VeeValidate, config)
global.jQuery = require('jquery')
var jQuery = global.jQuery
window.jQuery = jQuery
export default {
  props: {
    showmodelprop: {
      type: Boolean,
      default: false
    },
    copymodel: {
      type: Boolean,
      default: false
    },
    copyData: {
      type: Array
    }
  },
  data () {
    return {
      cdata: this.copyData,
      datasourceinfo: 'datasourceinfo info',
      uploadedfile: '',
      postURL: '',
      step: 1,
      step1: true,
      step2: false,
      step3: false,
      showmodel: this.showmodelprop,
      popmsgVisible: false,
      popinmessage: '',
      name: '',
      downloadChannelGroupingfile: '',
      res: [],
      time1: '',
      time2: '',
      start_date: '',
      end_date: '',
      market: [],
      countries: [],
      selectedMarket: [],
      customerType: [],
      soption: [],
      key: [],
      kpi: [],
      selectedKpi: [],
      client: '',
      formreturn: '',
      submit: false,
      selectedMarketSubmit: '',
      modelname: 'modelname',
      week: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
      ],
      commencingDay: 0,
      datasourcetype: [],
      datasourceSelected: 0,
      lookbacktypeselected: 0,
      predefinedlookback: false,
      lookbackValid: '',
      lookback: [{ value: 30, label: '30 Days' }, { value: 60, label: '60 Days' }, { value: 90, label: '90 Days' }],
      lookbackwindow: [{ value: 1, label: 'No lookback window' }, { value: 2, label: 'Custom Look Back Window' }],
      lookbackSelected: 0,
      daysinlookback: 0,
      channelgroupings: 'master',
      csvfilestring: '',
      reporttype: ['last-click-vs-bayesian', 'last-click'],
      reporttypeSelected: '',
      chusername: '',
      chagroupingdate: '',
      selectedcustomerType: [],
      ignorelookbackValid: false,
      missing_dates: [],
      dates_missing: [],
      missing_dates_datasourcetype: [],
      dates_missing_in_window: [],
      existing_channel_groupings_copy: 'yes'
    }
  },
  watch: {
    data: function () {
      // Clear previously selected values
    },
    selectedMarket: function () {
      return this.selectedMarket
    },
    showmodel: function () {
      return this.showmodel
    },
    time1: function () {
      this.dataAvailable()
    },
    time2: function () {
      this.dataAvailable()
    },
    copymodel: function (Newval, OldVal) {
      if (Newval) {
        this.getCdata(this.copyData)
      }
    }
  },
  inject: ['$validator'],
  aclient: 'options',
  components: {
    // Simplert,
    Datepicker
  },
  computed: {
    currentvalue: {
      set: function () {
        let time1 = this.time1
        let time2 = this.time2
        return {
          time2,
          time1
        }
      },
      get: function () {
        let time1 = this.time1
        let time2 = this.time2
        return {
          time2,
          time1
        }
      }
    },
    datetime () {
      return new Date()
    },
    formData () {
      return {
        name: this.name
      }
    }
  },
  methods: {
    reporttypeChange () {
      jQuery('.reporterror').hide()
      this.submit = true
      // this.formValid()
    },
    getCdata (objD) {
      this.cdata = objD[0]
    },
    setLookbacktype (lvalue) {
      let selectedvalue = lvalue
      if (selectedvalue === 3) {
        this.predefinedlookback = true
      } else if (selectedvalue === 1) {
        this.ignorelookbackValid = true
        this.predefinedlookback = false
      } else if (selectedvalue === 2) {
        if (this.lookbackSelected === 0) {
          this.lookbackSelected = 30
          this.checkLookbackNumber()
        }
        this.predefinedlookback = false
        this.ignorelookbackValid = false
      }
    },
    checkLookbackNumber () {
      if (this.lookbackSelected > 90 || this.lookbackSelected === 0) {
        this.lookbackValid = 'error'
      } else if (this.lookbacktypeselected === 2) {
        this.validLookback()
      }
    },
    onmyFileChange () {
      var self = this
      var theFormFile = this.$refs.filecomp.files[0]
      $.ajax({
        type: 'PUT',
        url: self.postURL,
        // Content type must much with the parameter you signed your URL with
        contentType: 'binary/octet-stream',
        // this flag is important, if not set, it will try to send data as a form
        processData: false,
        // the actual file is sent raw
        data: theFormFile,
        beforeSend: function () {
          self.$pingpong.displayLoader()
          jQuery('#createjotbtn').attr('disabled', 'disabled')
          jQuery('#createjotbtn').removeClass('enabled')
        },
        complete: function () {
          self.$pingpong.hideloader()
          jQuery('#createjotbtn').removeAttr('disabled')
          jQuery('#createjotbtn').addClass('enabled')
        },
        success: function (data) {
          // data = data['output']
          // self.uploadedfile = data.filepath
          console.log('file uploaded')
        },
        error: function () {
          alert('File NOT uploaded')
          console.log(arguments)
        }
      })
    },
    getSinedURL () {
      var self = this
      var outputurl = ''
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/urltoupload',
        data: { client: self.client, market: self.selectedMarketSubmit },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          // self.$pingpong.displayLoader()
        },
        complete: function () {
          // self.$pingpong.hideloader()
        },
        success: function (data) {
          data = data['output']
          self.postURL = data.url
          let str = data.key
          // self.uploadedfile = data.key
          // self.uploadedfile =
          // str = str.substring(str.indexOf('/') + 1)
          // str = str.replace(/^\/+|\/+$/g, '')
          self.uploadedfile = str
          // self.awss3.headers = {'Access-Control-Allow-Origin': '*', 'Content-Type': 'multipart/form-data'}
          // self.postfeilds = data.signature
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          // self.displaypopup()
        }
      })
      console.log(outputurl)
      return outputurl
    },
    captureResponce () {
      // console.log(this.$route.params.showmodel)
    },
    gotoNextStep: function (event) {
      // console.log(this.step)
      if (this.step === 1 && this.validdateStep1() === false) {
        this.popmsgVisible = true
        this.popinmessage = 'Please fill in the blank fields'
        return
      }
      if (this.step === 2 && this.validdateStep2() === false) {
        this.popmsgVisible = true
        this.popinmessage = 'Please fill in the blank fields / Enter Valid Data'
        return
      }
      this.step = this.step + 1
      this.setstep(this.step)
      this.popmsgVisible = false
    },
    gotoBackStep: function () {
      this.step = this.step - 1
      this.setstep(this.step)
    },
    validdateStep1: function () {
      // only validates if value is present
      if (this.name !== '' && this.client !== '' && this.selectedMarketSubmit !== '' && this.selectedKpi.length !== 0 && this.selectedcustomerType.length !== 0) {
        return true
      } else {
        console.log('error Step1')
        return false
      }
    },
    validdateStep2: function () {
      // only validates if value is present
      if (this.commencingDay && this.validLookback()) {
        return true
      } else {
        console.log('error Step1')
        return false
      }
    },
    validdateStep3: function () {
      // only validates if value is present
      // if (this.reporttypeSelected.length !== 0) {
      //   jQuery('.reporterror').hide()
      //   return true
      // } else {
      //   jQuery('.reporterror').show()
      //   return false
      // }
    },
    setstep: function (step) {
      if (step === 1) {
        if (!this.validdateStep1) {
          console.log('error Step1')
          return
        }
        this.step1 = true
        this.step2 = false
        this.step3 = false
        this.submit = false
      } else if (step === 2) {
        if (!this.validdateStep2) {
          console.log('error Step2')
          return
        }
        this.step2 = true
        this.step1 = false
        this.step3 = false
        this.$refs.step1arrow.classList.add('enable')
        this.selchannels = ''
        this.submit = false
      } else if (step === 3) {
        this.step2 = false
        this.step1 = false
        this.step3 = true
        jQuery('.CreatelModelstep2').addClass('enable')
      }
    },
    closeCreateModel () {
      let self = this
      let confirmCloseModal = {
        title: 'Are you sure you want to close Create Model?',
        type: 'info',
        useConfirmBtn: true,
        customConfirmBtnText: 'Yes',
        customCloseBtnText: 'No',
        customConfirmBtnClass: 'btn btn-primary',
        customCloseBtnClass: 'btn btn-primary',
        onConfirm: function () {
          jQuery('#create-job-form').trigger('reset')
          self.step = 1
          self.step1 = true
          self.step2 = false
          self.step3 = false
          self.showmodel = false
          self.$router.push({ path: '/', params: { 'showmodel': false }, query: { 'showmodel': false } })
          window.location.reload()
        }
      }
      this.$Simplert.open(confirmCloseModal)
    },
    modelpopupbuttonClick (obJD, type) {
      this.showmodel = true
      if (type !== undefined) {
        this.$nextTick(function () {
          this.setCopyData(obJD)
        })
      }
    },
    downloadChannelGrouping (e) {
      // attr('href', 'data:application/csv;charset=utf-8,'+ encodeURI(data))
      // var downloadObj = $('#downloadchannelgrouping')
      var self = this
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/GetChannelGroupings',
        data: { client: self.client, market: self.selectedMarketSubmit },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          self.$pingpong.hideloader()
        },
        success: function (data) {
          data = JSON.parse(data)
          // var blob = new Blob([data], { type: 'text/csv' })
          self.downloadChannelGroupingfile = '1'
          $('#downloadchannelgrouping').css({ visibility: 'visible' })
          $('#downloadchannelgrouping').attr(
            'href',
            'data:text/csv,' + data['channels-groupings']
          )
          $('#downloadchannelgrouping').attr('download', 'jobmaster.csv')
          // downloadObj.click()
          // return
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          // self.displaypopup()
        }
      })
    },
    onFileChange (e) {
      e.target.accept = '.csv'
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.createfile(files[0])
    },
    createfile (file) {
      // var image = new Image()
      var reader = new FileReader()
      reader.onload = (e) => {
        console.log(e.target.result)
        this.csvfilestring = e.target.result
      }
      reader.readAsDataURL(file)
    },
    validLookback () {
      if (this.ignorelookbackValid) {
        return true
      }
      this.daysinlookback = this.lookbackSelected
      this.daysinlookback = parseInt(this.daysinlookback)
      if (isNaN(this.daysinlookback)) {
        this.daysinlookback = 0
      }
      var date1 = moment(this.time1, 'DD-MMM-YYYY') // .format('DD-MM-YYYY')
      var date2 = moment(this.time2, 'DD-MMM-YYYY') // .format('DD-MM-YYYY')
      date1 = moment(date1)
      date2 = moment(date2)
      // date1 = (new Date(this.time1)).toUTCString() // user date
      // date2 = (new Date(this.time2)).toUTCString()
      var dateX = moment(this.start_date, 'DD-MM-YYYY')
      // new Date(this.start_date)).toUTCString()
      var dateY = moment(this.end_date, 'DD-MM-YYYY')
      // (new Date(this.end_date)).toUTCString()
      // alert(dateX)
      var differW = moment.duration(moment(dateX).diff(moment(date1))).asDays()
      // Math.max(0,num)
      console.log(differenceInDays(dateX, date1))
      if (differW > -0) {
        jQuery('.dateerror').show()
        return false
      } else {
        differW = Math.abs(differW)
        // moment(date1).utc() >= moment(dateX).utc() && moment(date2).utc <= moment(dateY).utc() && moment(date1).utc <= moment(date2).utc()
        if (
          moment(date1).isSameOrAfter(dateX) &&
          moment(date2).isSameOrBefore(dateY) &&
          moment(date2).isAfter(date1)
        ) {
          if (differW >= this.daysinlookback) {
            return true
          } else {
            this.displayLookupError()
            return false
          }
        } else {
          jQuery('.dateerror').show()
          return false
        }
      }
      // if()
    },
    dataAvailable () {
      var dates = []
      var d = []
      var date1 = moment(this.time1, 'DD-MMM-YYYY')
      var date2 = moment(this.time2, 'DD-MMM-YYYY')
      date1 = moment(date1)
      date2 = moment(date2)
      var currDate = moment(date1).startOf('day')
      var lastDate = moment(date2).startOf('day')
      console.log(this.dates_missing)
      dates.push(currDate.format('YYYY-MM-DD'))
      while (currDate.add(1, 'days').diff(lastDate) < 0) {
        dates.push(currDate.format('YYYY-MM-DD'))
      }
      dates.push(lastDate.format('YYYY-MM-DD'))
      this.dates_missing.forEach(function (data, index) {
        if (dates.indexOf(data) !== -1) {
          if (d.indexOf(data) === -1) {
            d.push(data)
          }
        }
      })
      this.dates_missing_in_window = d
    },
    onShowModal () {
      this.modal.visible = !this.modal.visible
    },
    clearInput (vueModel) {
      vueModel = ''
    },
    select: function (e) {
      // alert('a')
    },
    setdatasourceMessage (msg, value) {
      let dsmessage = msg
      let dvalue = value
      this.datasourceinfo = dsmessage
      this.dates_missing = this.missing_dates[this.soption].clientname.markets[this.selectedMarket].data_source[dvalue].missing_dates
      this.dataAvailable()
    },
    selectedClient (value) {
      // Clear previously selected values
      // console.log(this.soption)
      // console.log(this.res[this.soption])
      this.market = []
      this.selectedMarket = []
      // Populate list of countries in the second dropdown
      this.market = this.res[this.soption].clientname.markets
      this.client = this.res[this.soption].clientname.name
      this.$refs.selcountries.value = 0
      this.selectedMarket = 0
      this.setselectedMarket()
      this.setselectedKpi()
      // this.setdatasourceMessage()
    },
    setselectedMarket: function () {
      this.kpi = []
      this.selectedKpi = []
      this.selectedMarketSubmit = this.res[this.soption].clientname.markets[this.selectedMarket].name
      if (this.selectedMarket !== undefined) {
        this.kpi = this.res[this.soption].clientname.markets[this.selectedMarket].kpi
        this.customerType = this.res[this.soption].clientname.markets[this.selectedMarket].customer_type
        this.datasourcetype = this.res[this.soption].clientname.markets[this.selectedMarket].data_source
        this.setdatasourceMessage(this.datasourcetype[0].message, this.datasourcetype[0].value)
        this.reporttype = this.res[this.soption].clientname.markets[this.selectedMarket].report_type
        this.selectedKpi.push(this.kpi[0])
        this.time1 = moment(
          this.res[this.soption].clientname.markets[this.selectedMarket]
            .startdate,
          'DD-MM-YYYY'
        ).format('DD-MMM-YYYY')
        this.time2 = moment(
          this.res[this.soption].clientname.markets[this.selectedMarket]
            .enddate,
          'DD-MM-YYYY'
        ).format('DD-MMM-YYYY')
        this.start_date = moment(
          this.res[this.soption].clientname.markets[this.selectedMarket]
            .startdate,
          'DD-MM-YYYY'
        ).format('DD-MM-YYYY')
        this.end_date = moment(
          this.res[this.soption].clientname.markets[this.selectedMarket]
            .enddate,
          'DD-MM-YYYY'
        ).format('DD-MM-YYYY')
        // this.end_date = moment(
        this.chagroupingdate = moment(
          this.res[this.soption].clientname.markets[this.selectedMarket]
            .channel_groupings_modified
        ).format('llll')
        this.chusername = this.res[this.soption].clientname.markets[this.selectedMarket].channel_groupings_author
        this.chusername = this.chusername.split('-')[0]
        $('#downloadchannelgrouping').css({ visibility: 'visible' })
        // this.downloadChannelGrouping()
        this.missing_dates_datasourcetype = this.missing_dates[this.soption].clientname.markets[this.selectedMarket].data_source
      }
    },
    setselectedKpi () {
      if (this.selectedKpi.length !== 0) {
        this.submit = true
      } else {
        this.submit = false
      }
      return this.selectedKpi
    },
    setCopyData (objD) {
      this.cdata = objD[0]
      var setDatatoCopy = this.cdata
      var self = this
      this.res.map(function (e, i) {
        if (e.clientname.name === setDatatoCopy.client) {
          self.soption = i
          self.market = self.res[self.soption].clientname.markets
          self.name = setDatatoCopy.name
        }
      })
      this.res[self.soption].clientname.markets.map(function (e, i) {
        if (e.name === setDatatoCopy.selectedMarket) {
          self.selectedMarket = i
          self.$refs.selcountries.value = i
        }
      })
      self.setselectedMarket()
      console.log(setDatatoCopy)
      self.client = setDatatoCopy.client
      let cstype = function () {
        let returnn = []
        if (setDatatoCopy.customer_type === '12') {
          returnn = [1, 2]
        } else if (setDatatoCopy.customer_type === '102') {
          returnn = [0, 1, 2]
        } else if (setDatatoCopy.customer_type !== '12') {
          returnn = [setDatatoCopy.customer_type]
        }
        return returnn
      }
      this.selectedcustomerType = cstype()
      this.time1 = moment(setDatatoCopy.start_date, 'YYYY-MM-DD').format('DD-MMM-YYYY')
      this.time2 = moment(setDatatoCopy.end_date, 'YYYY-MM-DD').format('DD-MMM-YYYY')
      // this.user = setDatatoCopy.user
      this.commencingDay = setDatatoCopy.wcd
      this.daysinlookback = setDatatoCopy.lbw
      this.lookbackSelected = setDatatoCopy.lbw
      this.daysinlookback === 0 ? this.ignorelookbackValid = false : this.ignorelookbackValid = false
      // this.daysinlookback !== 0 ? this.lookbackSelected = 0 : this.lookbackSelected = this.daysinlookback
      this.daysinlookback === 0 ? this.lookbacktypeselected = 1 : this.lookbacktypeselected = 2
      this.channel_grouping_url = setDatatoCopy.url
      // this.reporttypeSelected = setDatatoCopy.report_type
      this.channelgroupings = setDatatoCopy.channel_grouping_type
      // setDatatoCopy.channel_grouping_type !== 'master' ? existing_channel_groupings_copy = 'yes'
      this.datasourceSelected = setDatatoCopy.ds
      this.chagroupingdate = setDatatoCopy.last_modified
      this.chusername = setDatatoCopy.user
      // this.selectedcustomerType = setDatatoCopy.customer_type
    },
    getData () {
      var self = this
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/GetLookupTable',
        data: {},
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          // jQuery('.dataspinner').show()
          this.isLoadingcompo = false
          self.$pingpong.hideloader()
        },
        success: function (data) {
          data = JSON.parse(data['lookup-data'])
          self.res = data
          console.log(self.res)
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.displaydownloadError()
        }
      })
    },
    getMissingDates () {
      var self = this
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/VoyagerGetMissingDates',
        data: {},
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          // self.$pingpong.displayLoader()
        },
        complete: function () {
          // jQuery('.dataspinner').show()
          this.isLoadingcompo = false
          // self.$pingpong.hideloader()
        },
        success: function (data) {
          data = JSON.parse(data['dates'])
          self.missing_dates = data
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.displaydownloadError()
        }
      })
    },
    displaypopup () {
      this.showmodel = false
      let obj = {
        title: 'Job Created',
        message: 'Your Job is created successfully',
        type: 'success',
        customClass: 'success',
        onClose: this.popuponClose,
        customCloseBtnText: 'Close'
      }
      this.$Simplert.open(obj)
      //
    },
    displaypopuperr () {
      let err = {
        title: 'Error',
        message: 'Your Job is not created',
        type: 'error',
        customClass: 'poperror'
      }
      this.$Simplert.open(err)
    },
    displayLookupError () {
      let err = {
        title: 'Error',
        message: 'Please select a lower start date',
        type: 'error',
        customClass: 'poperror'
      }
      this.$Simplert.open(err)
    },
    displaydownloadError () {
      let err = {
        title: 'Error',
        message: 'File Error',
        type: 'error',
        customClass: 'poperror'
      }
      this.$Simplert.open(err)
    },
    popuponClose () {
      // this.$router.push('/Displayjob')
      // this.$router.push("/createjob")
      window.location.reload()
    },
    formValid: function () {
      var self = this
      if (!this.validLookback()) {
        return
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (self.kpi.length > 0 && self.reporttypeSelected.length !== 0 && self.submit === true) {
            jQuery('.reporterror').hide()
            jQuery('.kpierror').hide()
            self.createAdministrator()
          } else if (self.reporttypeSelected.length === 0) {
            jQuery('.reporterror').show()
            self.submit = false
          } else if (self.kpi.length === 0) {
            jQuery('.kpierror').show()
            self.submit = false
          }
        } else {
          return
        }
      })
    },
    createAdministrator: function () {
      // Create mock user id. Replace this with actual user in future
      this.user = window.localStorage.getItem('user')
      this.time1 = moment(this.time1, 'DD-MMM-YYYY').format('DD-MM-YYYY')
      this.time2 = moment(this.time2, 'DD-MMM-YYYY').format('DD-MM-YYYY')
      var selectedCtTypestr = ''
      selectedCtTypestr = this.selectedcustomerType.join('')
      /*    var day = (60 * 60 * 24 * 1000)
              this.time1 = new Date(this.time1)
              this.time2 = new Date(this.time2)
              this.time1 = new Date(this.time1.getTime() + day)
              this.time2 = new Date(this.time2.getTime() + day) */
      var data = {
        name: this.name,
        client: this.client,
        selectedMarket: this.selectedMarketSubmit,
        selectedKpi: this.selectedKpi.join(','),
        start_date: this.time1,
        end_date: this.time2,
        user: this.user,
        wcd: this.commencingDay,
        lbw: this.daysinlookback,
        'channel-groupings': this.uploadedfile,
        'report-type': this.reporttypeSelected,
        'channel-grouping-type': this.channelgroupings,
        ds: this.datasourceSelected,
        'customer_type': selectedCtTypestr
      }
      // var data = ''' + this.name + '':'' + this.client + '''' + this.selectedMarket + '''' + this.selectedKpi + '''' + this.time2 + '''
      // console.log(data)
      var self = this
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/JobHandler',
        data: data,
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        xhr: function () {
          var xhr = new window.XMLHttpRequest()
          // Upload progress
          xhr.upload.addEventListener(
            'progress',
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = evt.loaded / evt.total
                // Do something with upload progress
                console.log(percentComplete)
              }
            },
            false
          )
          // Download progress
          xhr.addEventListener(
            'progress',
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = evt.loaded / evt.total
                // Do something with download progress
                console.log(percentComplete)
                if (percentComplete === 100) {
                  // t
                }
              }
            },
            false
          )
          return xhr
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
          // let currentPos = jQuery(window).scrollTop()
          // currentPos = currentPos + 100
          // jQuery('.spinner').css({ top: currentPos })
        },
        complete: function () {
          self.displaypopup()
          self.$pingpong.hideloader()
        },
        success: function (data) {
          console.log(data)
          console.log('success')
          jQuery('#create-job-form').trigger('reset')
          jQuery('.csvupload').val('')
          self.csvfilestring = ''
          // self.showmodel = false
          self.step = 0
          self.step1 = true
          self.step2 = false
          self.step3 = false
          // self.$router.push('/Displayjob')
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.displaypopuperr()
        }
      })
    }
  },
  created: function () {
    this.captureResponce()
  },
  mounted: function () {
    this.getData()
    this.getSinedURL()
    this.getMissingDates()
    this.$nextTick(function () {

    })
  },
  Update: function () {
    this.getData()
    this.setCopyData()
  }
}
</script>

<style lang='scss'>
.channel-grouping-msg {
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: normal;
  color: green;
  position: relative;
  b {
    color: #444;
    font-weight: normal;
  }
  a.download-channel-grouping {
    position: absolute;
    right: 0;
    top: -28px;
    border: none;
    font-weight: bold;
  }
}

.h6,
h6 {
  font-size: 18px;
  font-weight: bold;
}

.display-block {
  display: block;
}

.labltimerange {
  margin-bottom: 10px;
  display: block;
}

.dateerror {
  display: block;
  clear: both;
}

.success .simplert__title,
.success .simplert__body {
  color: green !important;
}

.poperror .simplert__title,
.poperror .simplert__body {
  color: red !important;
}

.disabled {
  pointer-events: none;
}

.vdp-datepicker {
  float: left;
  width: 25%;
  max-width: 340px;
  i {
    font-size: 1.6em;
    color: green;
  }
}

.vdp-datepicker input[type='text'] {
  padding: 0 5px;
  height: 3em !important;
  cursor: pointer;
  margin-bottom: 10px;
}

.datetime-picker input {
  height: 4em !important;
}

.datepicker .input-group-addon {
  position: absolute;
  float: right;
  top: 0;
  right: 0;
  width: 55px;
  height: 34px;
  cursor: pointer;
}

.datepicker .input-group-addon i {
  top: 2px;
  right: 0;
  position: relative;
}

.checkbox label:first-child {
  margin-left: 0;
}

.checkbox label {
  margin-left: 20px;
}

.lookbackradio {
  position: relative;
  input {
    margin-right: 10px;
    position: relative;
  }
  label {
    margin-bottom: 10px;
    position: relative;
    top: -2px;
    font-weight: normal;
  }
}

.kpiCheckbox {
  input[type='checkbox'] {
    margin: 0;
    min-height: 20px;
    height: 20px;
  }
  label {
    margin-left: 20px;
    margin: 0;
  }
}

.modal-mask {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modelpopContainer {
  width: 70vw;
  height: 80vh;
  margin: 0px auto;
  padding: 0;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  overflow-y: scroll;
  overflow-x: hidden;
  .content {
    padding: 0;
  }
}

.btncreateModel {
  margin-bottom: 30px;
  position: relative;

  span {
    padding: 10px 15px;
    background: #9fc54c;
    font-size: 20px;
    color: #fff;
    border-radius: 30px;
    z-index: 20;
    box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.2);
  }
  b {
    opacity: 0;
    position: absolute;
    left: 0px;
    top: 5px;
    transition: All 0.4s ease-in-out;
    transform: rotate(0deg) scale(0) skew(0deg) translate(0px);
    z-index: 1;
  }
  &:hover &:active &:focus {
    outline: none;
  }
  &:hover b {
    opacity: 1;
    display: block;
    padding: 5px;
    background: #9fc54c;
    border-radius: 4px;
    color: #fff;
    left: 0px;
    transition: All 0.2s ease-in-out;
    transform: rotate(0deg) scale(1) skew(0deg) translate(45px);
  }
}

a.close-btn {
  padding: 0 5px;
  color: #000;
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 0px;
  font-size: 25px;
  line-height: 34px;
}
.topSteps {
  margin-bottom: 20px;
  display: table;
  width: 100%;
}
.stepsheading {
  background-color: #898989;
  padding: 15px 30px;
  font-size: 18px;
  border-radius: 0px 0px 10px 0px;
  color: #fff;
}

.topSteps .stepsin {
  float: left;
  margin: 0 7%;
  span {
    line-height: 64px;
    display: inline-block;
    margin: 0 0 0 0;
    float: left;
  }
}
#create-job-form {
  padding: 20px;
}

.stepsin i {
  background: url('../../..//static/img/modelarrow.svg');
  display: inline-block;
  height: 62px;
  width: 64px;
  background-size: contain;
  background-repeat: no-repeat;
  margin: 4px 0 0 0;
  float: left;
}
.stepsin.active i,
.stepsin.enable i {
  background: url('../../..//static/img/modelarrow-col.svg');
  background-size: contain;
  background-repeat: no-repeat;
}
.topSteps .stepsin:first-child {
  margin: 0;
}

.Createjob-btnswrapper {
  text-align: right;
}

.form-control,
#create-job-form .input-group {
  width: 40%;
}
input.form-control.input {
  height: 3em;
}
select.form-control {
  background-color: #a7c35e;
  color: #fff;
}
.datasourceinfo {
  position: absolute;
  left: 15%;
  border: 1px solid #a7c35e;
  padding: 15px;
  top: 10px;
  border-radius: 10px;
  background-color: #fbfbfb;
}

.createmodelStep2 {
  position: relative;
  .lookbackradio label {
    top: 1px;
  }
}
.kpiCheckbox.checkbox span {
  display: block;
  margin-top: 10px;
}
</style>

<style scoped>
.btncreateModel.btn {
  background-color: none;
}
.togglebutton input {
  margin: 0;
  padding: 0;
  position: absolute;
  border: 0;
  height: 0;
  width: 0;
}
.togglebutton span {
  position: relative;
}
.togglebutton input + label {
  display: inline-block;
  margin: 0;
  padding: 0 20px;
  background: #e2e2e2;
  line-height: 30px;
  position: relative;
  width: 60px;
  color: #444;
}
.togglebutton input:checked + label {
  background: #9fc54c;
}

.togglebutton span:first-child label {
  border-radius: 5px 0px 0px 5px;
}

.togglebutton span:nth-child(even) label {
  border-radius: 0px 5px 5px 0px;
  margin-left: -1px;
}

.enterlookback input[type='number'] {
  width: 80px;
  margin-right: 10px;
}

.enterlookback {
  margin-left: 26px;
  position: absolute;
  top: 53px;
  left: 184px;
}

.form-group.loogback-group {
  position: relative;
}

.enterlookback span {
  font-size: 14px;
  color: #444;
}

.enterlookback span.error {
  color: red;
}

.predefinedlookback {
  margin-left: 30px;
}

.missingdateerror {
  font-size: 14px;
  color: #ffbf00;
}
#create-job-form .error {
  background-color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// Createjob.vue?161360e2